import { connect } from 'react-redux';

import {
  loadFeaturedBlog,
  loadPostCategories,
  loadPosts,
  resetCategories,
  resetPosts,
} from '../actions/resourcesActions';
import {
  getCategories,
  getFeaturedBlog,
  getIsLoading,
  getLoadMoreState,
  getPosts,
  getTotalPosts,
} from '../components/Resources/resourcesSelectors';
import ResourcesView from '../components/Resources/ResourcesView';

const mapStateToProps = (state, ownProps) => ({
  totalPosts: getTotalPosts(state),
  posts: getPosts(state),
  categories: getCategories(state),
  isLoading: getIsLoading(state),
  loadMoreState: getLoadMoreState(state),
  featuredBlog: getFeaturedBlog(state),
  per_page: 9,
  selectOrderOptions: [
    { id: 0, name: 'LATEST', value: 'desc' },
    { id: 1, name: 'OLDEST', value: 'asc' },
  ],
});
const mapDispatchToProps = (dispatch) => ({
  loadPosts: (page, limit, order, category) =>
    dispatch(loadPosts(page, limit, order, category)),
  loadCategories: () => dispatch(loadPostCategories()),
  resetPosts: () => dispatch(resetPosts()),
  resetCategories: () => dispatch(resetCategories()),
  loadFeaturedBlog: () => dispatch(loadFeaturedBlog()),
});

const ResourcesContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResourcesView);

export default ResourcesContainer;
